import { AuthAction, AuthActionType } from './auth.actions';
import { User } from '../model/user.model';

export const featureName = 'auth';

export interface AuthState {
  user: User;
  status: AuthStatus;
}

export type AuthStatus = 'loading' | 'initialized' | 'error';

const initialState: AuthState = { user: null, status: 'loading' };

export function authReducer(state: AuthState = initialState, action: AuthAction): AuthState {
  switch (action.type) {
    case AuthActionType.AUTH_INIT:
      return {
        user: null,
        status: 'loading'
      };

    case AuthActionType.AUTH_READY:
      return {
        user: action.payload.user,
        status: 'initialized'
      };

    case AuthActionType.AUTH_ERROR:
      return {
        user: null,
        status: 'error'
      };

    case AuthActionType.LOGIN:
      return {
        ...state
      };

    case AuthActionType.SYNC_LOGOUT:
    case AuthActionType.LOGOUT:
      return {
        ...state,
        user: null
      };

    case AuthActionType.REFRESH_USER:
      return {
        ...state,
        status: 'loading'
      };

    case AuthActionType.SET_ACCEPTANCES:
      return {
        ...state,
        user: { ...state.user, hasAcc: action.payload.hasAcc }
      };

    default:
      return state;
  }
}
